import { Flex, Icon, useColorMode, IconButton } from '@chakra-ui/react';
import { FiSun, FiMoon } from 'react-icons/fi';

const ModeSwitcher = ({ padding }) => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Flex justifyContent="center" alignItems="center" mt={{ base: '20px', md: 0 }}>
      {colorMode === 'dark' ? (
        <IconButton
          variant="dark"
          size="sm"
          bg={colorMode === 'dark' ? '#343444' : '-webkit-linear-gradient(right, #da0050, #8e2b88)'}
          // mr="10px"
          aria-label="Dark mode"
          icon={<FiSun color="#fff" fontSize="21px" />}
          onClick={colorMode === 'dark' ? toggleColorMode : null}
          zIndex={100}
        />
      ) : (
        <IconButton
          size="sm"
          variant="dark"
          bg={colorMode === 'dark' ? '-webkit-linear-gradient(right, #da0050, #8e2b88)' : '#343444'}
          aria-label="Dark mode"
          icon={<FiMoon color="#fff" fontSize="21px" />}
          onClick={colorMode === 'dark' ? null : toggleColorMode}
          zIndex={100}
        />
      )}
    </Flex>
  );
};
export default ModeSwitcher;
